export const UI_BUILD_VERSION = '2.7.11';
